import React from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import Pill from '@/shared/components/flip-ui-kit/Pill';
import useBoolean from '@/shared/hooks/useBoolean';
import { ArrowIcon, BoltIcon, PlusCircleIcon, SwapIcon } from '@/shared/icons/large';
import { DepositFundsModal } from '../Dashboard/DepositFundsModal';

const Action = ({
  title,
  description,
  icon,
  iconColor,
  soon,
  onClick,
}: {
  title: string;
  description: string;
  icon: React.ReactElement;
  iconColor: string;
  soon?: boolean;
  onClick?: () => Promise<boolean> | void;
}) => (
  <button
    type="button"
    className={classNames(
      'transition:ease-in flex items-center justify-between gap-x-3 rounded-md border border-cf-gray-3-5 bg-cf-gray-3 p-3 duration-150',
      onClick && 'hover:border-cf-gray-5 hover:bg-cf-gray-4',
    )}
    onClick={onClick}
  >
    <div className={classNames('flex items-center gap-x-3', soon && 'opacity-50')}>
      <div
        className={classNames(
          'flex h-8 w-8 items-center justify-center rounded-md border border-cf-gray-5',
          iconColor,
        )}
        style={{
          background: `radial-gradient(100% 100% at 50% 135.94%, rgba(255, 255, 255, 0.18) 0%, rgba(255, 255, 255, 0.00) 100%), radial-gradient(92.19% 92.19% at 50% -9.38%, rgba(255, 255, 255, 0.18) 0%, rgba(255, 255, 255, 0.00) 100%), #161616`,
        }}
      >
        {icon}
      </div>
      <div>
        <div className="text-start font-aeonikMedium text-12 text-cf-white">{title}</div>
        <div className="text-start font-aeonikRegular text-12 text-cf-light-3">{description}</div>
      </div>
    </div>
    {soon && (
      <div className="flex h-full items-start">
        <Pill color="green" text="Soon" />
      </div>
    )}
  </button>
);

export const QuickActions = () => {
  const {
    value: depositModalOpen,
    setTrue: openDepositModal,
    setFalse: closeDepositModal,
  } = useBoolean(false);

  const router = useRouter();

  return (
    <div className="grid grid-cols-2 gap-6 lg:grid-cols-4">
      <Action
        title="Deposit funds"
        description="Add more funds to your balances"
        icon={<PlusCircleIcon />}
        iconColor="text-cf-green-3"
        onClick={() => openDepositModal()}
      />
      <Action
        title="Swap funds"
        description="Exchange your funds with ease"
        icon={<SwapIcon />}
        iconColor="text-cf-blue-2"
        soon
      />
      <Action
        title="Earn BTC"
        description="Boost your BTC to earn yield"
        icon={<BoltIcon />}
        iconColor="text-cf-pink-1"
        onClick={() => router.push('/boost/positions')}
      />
      <Action
        title="Withdraw funds"
        description="Send your funds to a different wallet"
        icon={<ArrowIcon direction="up" />}
        iconColor="text-cf-orange-2"
        onClick={() => router.push('/balances')}
      />
      <DepositFundsModal
        open={depositModalOpen}
        onClose={closeDepositModal}
        onRedirect={() => undefined}
      />
    </div>
  );
};
